import { PostCodeModalWrap } from "./style";
import DaumPostcode, {Address} from 'react-daum-postcode'

interface PostCodeModalProps {
  onClose: () => void
  onAddress?: (data: Address) => void
}

export default function PostCodeModal ({onClose, onAddress}: PostCodeModalProps) {

  return (
    <PostCodeModalWrap>
      <div className="bg" onClick={() => onClose()}></div>
      <div className="modal">
        <DaumPostcode onComplete={(e: Address) => {
          if(onAddress) onAddress(e)
          onClose()
        }}/>
      </div>
    </PostCodeModalWrap>
  )
}
